import React from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  IconButton,
  Paper,
  Chip
} from '@mui/material';
import { 
  ArrowBack as ArrowBackIcon,
  CheckCircle as CheckCircleIcon 
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { isInApp } from '../../utils/environment';
const VerificationSuccess = ({ result={} }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location?.state;
  if (data) {    
    result = {
      orderId: data.couponId,
      amount: data.actualPrice,
      time: data.useTime,
      method: data.useType
    }
  }
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: '#F8F9FA',
        zIndex: 1300,
      }}
    >
      {/* Header */}
      {
        !isInApp() && (
          <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            p: 2,
            bgcolor: 'background.paper',
            borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
          }}
        >
          <IconButton
            onClick={() => navigate(-1)}
            edge="start"
            sx={{ mr: 2 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h6"
            sx={{
              fontSize: '1.25rem',
              fontWeight: 600
            }}
          >
            Verification Success
          </Typography>
        </Box>
        )
      }


      {/* Success Icon and Message */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: 4,
          pb: 3,
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: '50%',
            bgcolor: '#34C759',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <CheckCircleIcon 
            sx={{ 
              fontSize: 40, 
              color: 'white' 
            }} 
          />
        </Box>
        <Typography
          variant="h5"
          sx={{
            fontSize: '1.5rem',
            fontWeight: 600,
            mb: 1
          }}
        >
          Verification Successful!
        </Typography>
        <Typography
          sx={{
            color: 'text.secondary',
            textAlign: 'center'
          }}
        >
          The order has been successfully verified
        </Typography>
      </Box>

      {/* Order Details */}
      <Box sx={{ px: 3 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: '1.25rem',
              fontWeight: 600
            }}
          >
            Order Details
          </Typography>
          <Chip 
            label="Verified" 
            sx={{
              bgcolor: 'rgba(52, 199, 89, 0.1)',
              color: '#34C759',
              borderRadius: 1,
              height: 24
            }}
          />
        </Box>

        <Paper
          elevation={0}
          sx={{
            bgcolor: 'white',
            borderRadius: 2,
            p: 3,
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography sx={{ color: 'text.secondary' }}>Order ID</Typography>
            <Typography sx={{ fontWeight: 500 }}>#{result?.orderId || ''}</Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography sx={{ color: 'text.secondary' }}>Amount</Typography>
            <Typography sx={{ fontWeight: 500 }}>${result?.amount || ''}</Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography sx={{ color: 'text.secondary' }}>Verification Time</Typography>
            <Typography sx={{ fontWeight: 500 }}>{result?.time || ''}</Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography sx={{ color: 'text.secondary' }}>Verification Method</Typography>
            <Typography sx={{ fontWeight: 500 }}>{result?.method || ''}</Typography>
          </Box>
        </Paper>
      </Box>

      {/* Action Buttons */}
      <Box
        sx={{
          position: 'fixed',
          bottom: 24,
          left: 24,
          right: 24,
          display: 'flex',
          gap: 2
        }}
      >
        <Button
          variant="outlined"
          fullWidth
          onClick={() => navigate('/campaigns/invitations/verification-history')}
          sx={{
            borderRadius: 2,
            py: 1.5,
            borderColor: 'rgba(0, 0, 0, 0.12)',
            color: 'text.primary',
            textTransform: 'none',
            fontSize: '1rem',
            '&:hover': {
              borderColor: 'rgba(0, 0, 0, 0.24)',
              bgcolor: 'rgba(0, 0, 0, 0.04)'
            }
          }}
        >
          View History
        </Button>
        <Button
          variant="contained"
          fullWidth
          onClick={() => navigate('/campaigns/invitations/enter-code')}
          sx={{
            borderRadius: 2,
            py: 1.5,
            bgcolor: 'black',
            textTransform: 'none',
            fontSize: '1rem',
            '&:hover': {
              bgcolor: '#333'
            }
          }}
        >
          New Verification
        </Button>
      </Box>
    </Box>
  );
};

export default VerificationSuccess; 